/**
 * @author Sumit Majumdar
 * @email sumit@grexit.com
 * @create date 2018-03-28 11:26:23
 * @modify date 2018-03-28 11:26:23
 * @desc [description]
*/
import { HiverAxios } from 'h-commons';
import { 
    FETCH_CONNECTOR_DONE,
    FETCH_CONNECTOR_INIT,
    FETCH_CONNECTOR_FAILED,
    typePrefixMap,
    getConnectorChannels
} from './';
/**
 * redux async action to retrieve connector enabled status and other related information
 * @param  {string} type         Connector Type
 * @param  {string|number} smid  Shared Mailbox Id  
 */
export const getConnectorEnabled = (type, smid) => dispatch => {
    if (!(type in typePrefixMap)) {
        dispatch({
            type: FETCH_CONNECTOR_FAILED,
            error: 'Unsupported Connector'
        });
        return;
    }
    dispatch({
        type: FETCH_CONNECTOR_INIT
    });
    const prefix = typePrefixMap[type];
    HiverAxios({
        url: `${prefix}/get?smid=${smid}`,
        type: 'get',
        callback: resp => {
            if (resp.data) {                
                dispatch({
                    type: FETCH_CONNECTOR_DONE,
                    payload: { ...resp.data, smid, type } //only returns enabled, channel name currently selected and checked options
                });
                if (!!resp.data.enabled) //if connector enabled get it's channels list
                    dispatch(getConnectorChannels(type, smid));
            } else
                dispatch({
                    type: FETCH_CONNECTOR_FAILED,
                    error: 'Something wrong happened'
                });
        },
        onfail: err => {
            dispatch({
                type: FETCH_CONNECTOR_FAILED,
                error: err
            });
        }
    });
}